export var TWITTER_CARD_SUPPORTED_TYPES = {
    SUMMARY: 'summary',
    SUMMARY_LARGE_IMAGE: 'summary_large_image',
};
